module.exports = ".sha-signin-regis {\n\tmargin-top: 40px;\n}\n.sha-signin-right {\n\tpadding: 90px 60px 30px 60px; \n}\n.sha-signin-regis {\n\theight: auto;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/forgot.component.css
// module id = 1574
// module chunks = 0